/* eslint-disable class-methods-use-this */
/* eslint-disable no-new-wrappers */
const sendDataLayer = (object) => {
    window.dataLayer.push(object);
};

class GTM {
    sendProductImpression(products) {
        const dl = {
            event: 'impressions',
            ecommerce: {
                event: 'impressions',
                currencyCode: products.currency,
                impressions: [...products.product],
            },
        };

        sendDataLayer(dl);
    }

    trackProductImpression(products) {
        let isCreatedData = false;

        window.dataLayer.forEach((ecommerceObj) => {
            if (ecommerceObj.ecommerce) {
                if (ecommerceObj.ecommerce.impressions) {
                    // eslint-disable-next-line no-param-reassign
                    ecommerceObj.ecommerce.impressions = [...products.product];
                    isCreatedData = true;
                }
            }
        });

        if (!isCreatedData) {
            this.sendProductImpression(products);
        }
    }

    trackProductDetail(products) {
        const dl = {
            event: 'product-detail',
            ecommerce: {
                currencyCode: products.currency,
                detail: {
                    product: [...products.product],
                },
            },
        };

        sendDataLayer(dl);
    }

    updateTrackProductDetail(prodObj) {
        window.dataLayer.forEach((ecommerceObj) => {
            if (ecommerceObj.ecommerce) {
                if (ecommerceObj.ecommerce.detail) {
                    // eslint-disable-next-line no-param-reassign
                    ecommerceObj.ecommerce.detail.product = prodObj;
                }
            }
        });
    }

    trackQuickViewClickProduct(kindEvent, product) {
        const dl = {
            event: kindEvent, // ex: productQuickViewClick, promotionClick
            ecommerce: {
                click: {
                    actionField: { list: product.category },
                    products: [...product.product],
                },
            },
        };

        sendDataLayer(dl);
    }

    trackClickedProduct(kindEvent, product) {
        const dl = {
            event: kindEvent, // ex: productQuickViewClick, promotionClick
            ecommerce: {
                click: {
                    actionField: { list: product.list },
                    products: [...product.product],
                },
            },
            eventCallback: () => {
                document.location = product.productUrl;
            },
        };

        sendDataLayer(dl);
    }

    // track some event in some option
    trackEventOption(kindEvent, option) {
        const dl = {
            event: `${kindEvent} ${option.labelText}`,
            selectedElement: option.elementTarget,
        };

        sendDataLayer(dl);
    }

    trackAddProductToCart(prod, list) {
        const dl = {
            event: 'addToCart',
            ecommerce: {
                currencyCode: prod.currencyCode,
                add: {
                    actionField: {
                        list,
                    },
                    products: prod.product,
                },
            },
        };

        sendDataLayer(dl);
    }

    trackDeleteProductToCart(prod) {
        const dl = {
            event: 'removeFromCart',
            ecommerce: {
                remove: {
                    products: prod,
                },
            },
        };

        sendDataLayer(dl);
    }

    trackCheckoutStep(cart, actionField, currencyCode) {
        const dl = {
            event: 'checkout',
            ecommerce: {
                currencyCode,
                checkout: {
                    actionField,
                    products: [...cart],
                },
            },
        };

        sendDataLayer(dl);
    }

    trackCheckoutSuccess(order) {
        const products = [...order.products];
        const dl = {
            event: 'purchase',
            ecommerce: {
                purchase: {
                    actionField: order.data,
                    products,
                },
                currencyCode: order.currencyCode,
            },
        };

        sendDataLayer(dl);
    }
}

module.exports = new GTM();
